




















































import { Vue, Component } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { User } from "@/modules/auth/types";
import { PersonalPayload } from "../types";

const Auth = namespace("auth");
const Settings = namespace("settings");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Profile",
    };
  },
})
export default class Profile extends Vue {
  @Auth.Getter("getUser") user: User;
  @Settings.Action("postPersonalInformation") postPersonal!: (
    payload?: PersonalPayload
  ) => Promise<{}>;

  loading = false;
  error = "";

  personalForm = {
    firstName: "",
    lastName: "",
  };

  mounted() {
    this.personalForm.firstName = this.user.firstName;
    this.personalForm.lastName = this.user.lastName;
  }
  submitForm() {
    this.loading = true;

    this.postPersonal({
      firstName: this.personalForm.firstName,
      lastName: this.personalForm.lastName,
    })
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Profile updated successfully",
        });
      })
      .catch(() => {
        this.loading = false;
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to update profile.",
        });
      });
  }
  validations() {
    return {
      personalForm: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
      },
    };
  }
}
